import Phaser from "phaser";
import LoadingScene from "@/games/Kombat/scenes/LoadingScene";
import QuestionScene from "@/games/Kombat/scenes/QuestionScene";
import PlayScene from "@/games/Kombat/scenes/PlayScene";
import LandingScene from "@/games/Kombat/scenes/LandingScene";
import Settings from "@/games/Kombat/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      PlayScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
